// extracted by mini-css-extract-plugin
export default {"heading":"jQ","container":"kQ","product_section_row":"lQ","carousel":"mQ","carouselwide":"nQ","carouselwrapper":"oQ","blockwrapper":"pQ","product_carousel_row":"qQ","headingnarrow":"rQ","title":"sQ"};
    if(module.hot) {
      // 1715091680637
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  